/**
 * Challenges Module
 * Exports all components, hooks, and types for the challenges feature
 */

// Types
export * from "./types";

// Hooks
export { useChallenges } from "./hooks/useChallenges";
export { useChallengeDetail } from "./hooks/useChallengeDetail";
export { useUserChallenges } from "./hooks/useUserChallenges";
export { useOpdrachtDetail } from "./hooks/useOpdrachtDetail";
export { useOpdrachtSections } from "./hooks/useOpdrachtSections";

// Components
export { ChallengeCard } from "./components/ChallengeCard";
export { ChallengePicker } from "./components/ChallengePicker";
export { CreatePhotoChallengeModal } from "./components/CreatePhotoChallengeModal";
export { CreateOpdrachtModal } from "./components/CreateOpdrachtModal";

